export interface Service {
  src: string;
  title: string;
  text: string;
}

export const services: Service[] = [
  {
    src: "fundicion.webp",
    title: "Fundición",
    text: "Bronce, latón, aluminio y más, vaciados a la medida de tu proyecto.",
  },
  {
    src: "esculturas.webp",
    title: "Esculturas",
    text: "Obras de arte en metal, desde piezas de escritorio hasta monumentales.",
  },
  {
    src: "medallas.webp",
    title: "Medallas",
    text: "Medallas conmemorativas y deportivas con acabados de alto relieve.",
  },
  {
    src: "trofeos.webp",
    title: "Trofeos",
    text: "Trofeos únicos que hacen memorable cada logro.",
  },
  {
    src: "reconocimiento.webp",
    title: "Reconocimientos",
    text: "Placas y galardones para premiar la excelencia.",
  },
  {
    src: "monedas.webp",
    title: "Monedas",
    text: "Monedas y fichas acuñadas con diseño personalizado.",
  },
  {
    src: "joyeria.webp",
    title: "Joyería",
    text: "Piezas finas trabajadas con precisión artesanal.",
  },
  {
    src: "placas.webp",
    title: "Placas",
    text: "Placas metálicas grabadas para interior y exterior.",
  },
  {
    src: "grabado.webp",
    title: "Grabado",
    text: "Grabado de precisión en metal, madera, vidrio y más.",
  },
  {
    src: "torneado.webp",
    title: "Torneado",
    text: "Maquinado y torneado de piezas con tolerancias exactas.",
  },
  {
    src: "bandera.webp",
    title: "Pines",
    text: "Pines metálicos esmaltados con la identidad de tu marca.",
  },
  {
    src: "llaveros.webp",
    title: "Llaveros",
    text: "Llaveros metálicos personalizados para cualquier ocasión.",
  },
  {
    src: "promocional.webp",
    title: "Promocionales",
    text: "Artículos promocionales que dejan huella.",
  },
  {
    src: "bordado.webp",
    title: "Bordados",
    text: "Bordado de escudos, parches y prendas institucionales.",
  },
  {
    src: "sublimacion.webp",
    title: "Sublimación",
    text: "Impresión a todo color sobre textiles y superficies.",
  },
  {
    src: "3d.webp",
    title: "Impresión 3D",
    text: "Prototipos y modelos para fundición en tiempo récord.",
  },
];
